export default __webpack_public_path__ + "static/media/sofa-1-seat-3-back.145e7afd.webp";